export const text = {
  text: {
    color: '{slate.700}',
    colorSecondary: '{slate.600}',
    colorThird: '{slate.300}',
    mutedColor: '{slate.600}',
    hoverColor: '{slate.600}',
    // mutedColor?: string;
    // hoverMutedColor?: string;
  },
};
